export default __webpack_public_path__ + "static/media/lines.748edace.svg";